import React from "react";
import Button from "@components/Button/Button";
import boxMaterial from '@/assets/icons/material-box.png';
import laptopMaterial from '@/assets/icons/material-laptop.png';
import { Image } from "react-bootstrap";

interface MaterialBoxProps {
  boxNumber: number;
  totalBoxes: number;
  status?: string;
  shippedDate?: string;
  itemDescription?: string; 
  itemTypeCode?: string; 
}

const MaterialBox: React.FC<MaterialBoxProps> = ({ boxNumber, totalBoxes, status, shippedDate, itemDescription, itemTypeCode }) => {
  let iconSrc = boxMaterial; 
  if (itemTypeCode == "4") {
    iconSrc = laptopMaterial; 
  }
  
  const statusLabel =
    status?.toLowerCase() === "shipped" && shippedDate
      ? `Shipped on ${shippedDate}`.trim()
      : status
      ? status.charAt(0).toUpperCase() + status.slice(1) 
      : "Preparing to Ship";
  return (
    <div className="material-box">
        <div className="material-box__icon">
          <Image src={iconSrc} fluid alt="Material Icons" />
        </div>

      <div className="material-box__innerblock">
        <div className="material-box__eyebrow">
          ITEM {boxNumber} OF {totalBoxes}
        </div>
       <div className="material-box__status">
          <span>{statusLabel}</span>
          {!status && <span>&nbsp;</span>} 
        </div>
      </div>
    </div>
  );
};

// Boxes Props in LearningMaterialsSection
interface LearningMaterialsProps {
  eyebrow: string;
  header: string;
  description: React.ReactNode;
  boxes: MaterialBoxProps[];
    trackingCtaUrl?: string;

}
const LearningMaterialsSection: React.FC<LearningMaterialsProps> = ({
  eyebrow,
  header,
  description,
  boxes,
  trackingCtaUrl
}) => {
  return (
    <div className="learning-materials-section">
      <div className="learning-materials-section__left">
        <div className="learning-materials-section__eyebrow">{eyebrow}</div>
        <h2 className="learning-materials-section__header">{header} </h2>
        <p className="learning-materials-section__description">{description}</p>
      </div>
      <div className="learning-materials-section__right">
        {boxes.map((box, idx) => (
          <MaterialBox key={idx} {...box} />
        ))}
        <Button
        label="More Tracking Info"
        size="lg"
        variant="border"
        width="fit-content"
        color="primary"
        breakpoint="all"
        className="learning-materials-section__tracking-link"
        linkUrl={ trackingCtaUrl }
        linkTarget="_self"
    />
      </div>
      
    </div>
  );
};

export default LearningMaterialsSection;
